import { Select } from 'antd'

export function calculateAssignmentOptions(userData, isAssignFunction = true) {
  const allUsers = []

  if (userData && Array.isArray(userData)) {
    userData.forEach(user => {
      const option = (
        <Select.Option key={user.userId} value={user.displayName}>
          {user.displayName}
        </Select.Option>
      )
      allUsers.push(option)
    })
  }

  const users = [
    <Select.Option
      key="unassigned"
      value={isAssignFunction ? null : 'unassigned'}
    >
      <i>Unassigned</i>
    </Select.Option>,
    <Select.Option key="backdated" value={'backdated'}>
      <i>Backdated</i>
    </Select.Option>,
    <Select.OptGroup key="qflowUsers" label="Qflow users">
      {allUsers}
    </Select.OptGroup>
  ]
  return users
}
